import { setSessionStorageItem } from '../../sessionStorage/utils';
import { SESSION_STORAGE_GIFTCARD_PAYMENT } from '../../../utils/constants';

export default (giftCardPaymentVar) => {
  return (newGiftCardPayment) => {
    giftCardPaymentVar(newGiftCardPayment);
    setSessionStorageItem(SESSION_STORAGE_GIFTCARD_PAYMENT, newGiftCardPayment);
  };
};
